import _ from "lodash";
import {
  DATA_GRID_COLUMNS,
  STANDARDS_DATA_GRID_PROPERTIES,
} from "./stringConstants";
import { DATA_GRID_COLUMN_TYPES } from "StandardsTable/modules/constants";
import getCheckboxValue from "StandardsTable/modules/cellUtils/getCheckboxValue";

export const getCurrentColumns = ({ isCourseBasedGrading }) => {
  if (isCourseBasedGrading) {
    return DATA_GRID_COLUMNS;
  }

  return _.without(DATA_GRID_COLUMNS, DATA_GRID_COLUMN_TYPES.SUBJECT_AREAS);
};

export const getMetadata = ({ node, parentId, nodeMap }) => {
  const { isArchived = false } = node?.dataSetNodeWrapper?.properties || {};
  const parentUID = parentId ? nodeMap.get(parentId)?.uid : "-";

  return {
    isArchived,
    parentUID,
    isTaggingDisabled: isArchived,
  };
};

export const getColumnProperties = ({ columns }) => {
  const reducedProperties = _.reduce(
    columns,
    (acc, column) => {
      acc[column] = {
        cellConfig: {
          styles: {
            selectedColor: "white",
          },
        },
      };
      return acc;
    },
    {}
  );

  return _.merge({}, reducedProperties, STANDARDS_DATA_GRID_PROPERTIES);
};

export const getEdgesFromNodeMap = ({
  nodeMap,
  selectionColIndex,
  selectedStandards,
  isParentTaggingEnabled,
}) =>
  Array.from(nodeMap.values(), ({ rowId, columns, children, metadata }) => {
    if (selectionColIndex !== -1) {
      const isSelected = selectedStandards.has(rowId);
      columns[selectionColIndex].value = getCheckboxValue({
        value: isSelected,
      });
      const { isTaggingDisabled } = metadata || {};

      if (!isSelected && isTaggingDisabled) {
        columns[selectionColIndex].isDisabled = true;
      }

      if (!isParentTaggingEnabled) {
        // if node is parent and not selected, disable the checkbox
        if (!_.isEmpty(children) && !isSelected) {
          columns[selectionColIndex].isDisabled = true;
        }
      }
    }
    return {
      rowId,
      columns,
      children,
    };
  });
